(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2045],{

/***/ 18802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ StoreServiceDetail; }
/* harmony export */ });
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75046);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87607);
/* harmony import */ var components_views_ProductListing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56493);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var layouts_LocationLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12424);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41248);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57731);
/* harmony import */ var lib_features_productSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21475);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);











var __N_SSP = true;
function StoreServiceDetail(props) {
  var _page = props.page,
      _filter = props.filter,
      _sort = props.sort,
      deals = props.allDeals,
      CATEGORIES = props.CATEGORIES;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
  var location = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.location.location;
  });
  var services = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.product.services;
  });
  var brands = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.brand.brands;
  });
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      filteredServices = _useState[0],
      setFilteredServices = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (!!location.services && services.length > 1) {
      var relatedServicesId = location.services.includes(',') ? location.services.split(', ') : [location.services];
      console.log('here: ', relatedServicesId, services);
      var tempServices = relatedServicesId.map(function (item) {
        var service = services.find(function (p) {
          return p.id === item;
        });

        if (!!service) {
          return service;
        } else {
          return {
            id: "-1"
          };
        }
      });
      console.log('at service tab: ', tempServices);
      setFilteredServices(tempServices.filter(function (item) {
        return Number(item.id) > 0;
      }));
    }

    setLoaded(true);
  }, [services, location]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (services[0].id === 0 && services.length === 1) {
      dispatch((0,lib_features_productSlice__WEBPACK_IMPORTED_MODULE_7__/* .getPaginatedServicesThunk */ .dl)({
        _page: _page,
        _filter: _filter,
        _sort: _sort
      }));
    }
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: loaded ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_views_ProductListing__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        _filter: _filter,
        _page: _page,
        _sort: _sort,
        products: filteredServices,
        deals: deals,
        brands: brands,
        type: 'Service',
        categories: CATEGORIES,
        baseUrl: "/stores/".concat(location.slug, "/servicemenu")
      }) : null
    })
  });
}

StoreServiceDetail.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(layouts_LocationLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      children: page
    })
  });
};

/***/ }),

/***/ 82879:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[locationSlug]/[id]/service",
      function () {
        return __webpack_require__(18802);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,3714,4909,2531,120,6393,7607,2424,6493,9774,2888,179], function() { return __webpack_exec__(82879); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);